// UUID v7 utility for generating time-ordered UUIDs
// UUIDv7 provides better database performance and sortability compared to UUIDv4

import { uuidv7 } from "uuidv7";

/**
 * Generates a UUIDv7 (time-ordered UUID)
 *
 * UUIDv7 benefits:
 * - Time-ordered: Can be sorted chronologically
 * - Better database performance: Sequential IDs improve B-tree index performance
 * - K-sortable: Maintains lexicographic order
 * - Compatible with standard UUID format
 *
 * @returns A UUIDv7 string
 */
export function generateUUID(): string {
  return uuidv7();
}

/**
 * Legacy alias for backward compatibility
 * @deprecated Use generateUUID() instead
 */
export const randomUUID = generateUUID;
